import httpClient from '@/libs/http-client'

export function userDetail(params) {
  const url = '/api/super/member/detail'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

export function userModify(params) {
  const url = '/api/'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

export function memberRateUpdata(params) {
  const url = '/api/admin/member/updateRate'
  return httpClient.post(url, params).then(response => {
    return response.data
  })
}

export function memberDelete(params) {
  const url = '/api/super/company/deleteUsers'
  return httpClient.post(url, params, { timeout: 120000 }).then(response => {
    return response.data
  })
}

